/**
 * La Función recibe un objeto con la info del formulario y lo convierte en un array para procesar la data.
 * @param {Object} phonesData
 * @returns devuelve un Array de objetos con la info del formulario para realizar el update.
 */
const sendProcessUserPhones = phonesData => {
  // Se arma array con los values de contactData:
  const arrayData = phonesData && Object.values(phonesData);
  const processData = arrayData.map(item => {
    // Se elimina la key 'isValid' de cada elemento:
    const { isValid, ...restKeys } = item;
    // (NO ELIMINAR la key 'isValid' del destructuring, dado que de esa manera la abstraemos del resto de keys):
    return restKeys;
  });
  // Se de filtran los elementos que tienen el number distinto de vacío: [{number: 123456, prefix: 54, type: 'PHONE'}, ...{}]:
  const processDataArray =
    processData &&
    processData.map(item => ({
      number: ['', null].includes(item.number) ? '' : item.number,
      prefix: ['', null].includes(item.number) ? '' : item.prefix,
      type: item.type
    }));
  return processDataArray;
};

/**
 * La función evalúa, según los argumentos recibidos, qué key debe devolver para setear el border-color del css:
 * @param {boolean} phoneValid
 * @param {boolean} editedValue
 * @param {boolean} emptyInputError
 * @returns devuelve un string con la key para setear el border-color
 */
const getValidBorder = (phoneValid, editedValue, emptyInputError) => {
  // Si el input está vacío se seteará en color rojo:
  if (emptyInputError) return 'isNotValid';
  // Si el valor es editado luego se sacar el focus del input se seteará en color negro:
  if (editedValue) return 'defaultValue';
  // Si se consume desde el servicio y es isValid = false  se seteará en color rojo:
  if (!phoneValid) return 'isNotValid';
  return 'defaultValue';
};
export { sendProcessUserPhones, getValidBorder };
